const ABERTURAS = [
    'Escutar o cliente',
    'Conectar tecnologia a uma necessidade real',
    'Contar a mesma história em produto e atendimento',
    'Fazer a pergunta certa',
    'Simplificar o benefício',
    'Cuidar da jornada depois da entrega',
    'Conhecer o produto a fundo',
    'Cuidar de cada ponto de contato',
    'Trabalhar em equipe',
    'Respeitar o tempo do cliente',
];

const DESFECHOS = [
    'transforma a conversa em confiança.',
    'torna a experiência mais relevante.',
    'faz a marca ser lembrada.',
    'revela o que realmente importa.',
    'gera valor que o cliente percebe.',
    'aproxima a loja da vida do cliente.',
    'transforma informação em solução.',
    'constrói relacionamento duradouro.',
    'diferencia o atendimento da concorrência.',
    'faz o cliente voltar e indicar.',
];

/** 100 destaques sintéticos (10 × 10), sem relação com a tabela de insights. */
export const BOSS_FINAL_INSIGHTS_MOCK = Object.freeze(
    ABERTURAS.flatMap((abertura, i) => DESFECHOS.map((desfecho, j) => Object.freeze({
        id: `mock-${String(i * DESFECHOS.length + j + 1).padStart(3, '0')}`,
        grupo_id: `GRUPO ${((i * DESFECHOS.length + j) % 17) + 1}`,
        ordem: 0,
        texto: `${abertura} ${desfecho}`,
    }))),
);

/** Quantos destaques a timeline exibe (`BOSS_FINAL_HIGHLIGHT_LIMIT`). */
export const BOSS_FINAL_DESTAQUES_SORTEADOS = 7;

/** Sorteio sem repetição (Fisher-Yates parcial); `aleatorio` injetável para teste. */
export function sortearInsightsMock({
    quantidade = BOSS_FINAL_DESTAQUES_SORTEADOS,
    aleatorio = Math.random,
} = {}) {
    const pool = [...BOSS_FINAL_INSIGHTS_MOCK];
    const total = Math.min(quantidade, pool.length);
    for (let i = 0; i < total; i += 1) {
        const j = i + Math.floor(aleatorio() * (pool.length - i));
        [pool[i], pool[j]] = [pool[j], pool[i]];
    }
    return pool.slice(0, total).map((insight, ordem) => ({ ...insight, ordem: ordem + 1 }));
}

/** Substitui `buscarFotografia`: mesma assinatura, sem rede. */
export function criarBuscarFotografiaMock(opcoes) {
    return async function buscarFotografiaMock() {
        return sortearInsightsMock(opcoes);
    };
}
